import p5 from "p5";
import { TWO_PI, PHI, SQR_2 } from "./local_mods/math_constants.js";
import {
  frand_rng, // K
  frand_rng_int,
  arr_pick,
  fib_num, // H
  lerp,
  fx_shuffle_arr,
  calculateAspectRatioFit,
  get_datetime_str, // R
  clamp,
} from "./local_mods/util.js";
import { init_scene } from "./scene.js";
import { postcard_triangles_clrs } from "./local_mods/colour_palettes.js";

new p5((p55) => {
  console.clear(); // I
  let config = {
    sketch_name: "Postcard Triangles",
    author: "sspboyd",
  };

  let cell_w, cell_h;
  let clr1, clr2, clr3;

  let cols = arr_pick([3, 4, 7, 11, 18]);
  let rows = cols;
  let preview_triggered = false;

  let flips_per_cell = 3;
  let coin_flips = [];
  let clr_pal = arr_pick(postcard_triangles_clrs);
  fx_shuffle_arr(clr_pal.clrs);

  let scene = init_scene();

  $fx.features({
    "Grid Dimensions": `${cols} x ${rows}`,
    "Colour Palette": `${clr_pal.title}`,
  });
  console.log("Postcard Triangles by Stephen Boyd, sspboyd.ca");
  console.log("October 13, 2023");
  console.log("Colour Palette: " + clr_pal.title);
  console.log(`Grid dimensions: ${cols}x${rows}`);
  console.log(`fxhash: ${fxhash}`);
  /////////////// S
  ///////////////////////////
  ////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////

  p55.setup = () => {
    cell_w = Math.floor(scene.min_dim / cols);
    cell_h = cell_w;
    let grid_w_px = cell_w * cols;
    let grid_h_px = grid_w_px;
    p55.createCanvas(grid_w_px, grid_h_px);

    p55.pixelDensity(5);
    p55.background(255);

    clr1 = p55.color(clr_pal.clrs[0]);
    clr2 = p55.color(clr_pal.clrs[1]);
    clr3 = p55.color(clr_pal.clrs[2]);

    // set coin flips for each grid
    for (let c = 0; c < cols; c++) {
      for (let r = 0; r < rows; r++) {
        let curr_cell_flips = [];
        for (let flip_num = 0; flip_num < flips_per_cell; flip_num++) {
          curr_cell_flips.push(flip_val());
        }
        coin_flips.push(curr_cell_flips);
      }
    }
    p55.noStroke();
  };

  p55.draw = () => {
    p55.background(clr3);

    let cell_x, cell_y; // x and y positions for each grid
    let cg = []; // coin flips for the Current Grid position/cell

    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        cell_x = c * cell_h;
        cell_y = r * cell_w;
        cg = coin_flips[r * rows + c];
        if (cg[2]) {
          p55.fill(clr2);
          p55.rect(cell_x, cell_y, cell_w, cell_h);
        }
        p55.fill(clr1);
        if (cg[0] === 1 && cg[1] === 1) {
          // Heads, Heads
          p55.triangle(
            cell_x,
            cell_y,
            cell_x + cell_w,
            cell_y,
            cell_x + cell_w,
            cell_y + cell_h
          );
        } else if (cg[0] === 1 && cg[1] === 0) {
          // Heads, Tails
          p55.triangle(
            cell_x,
            cell_y,
            cell_x,
            cell_y + cell_h,
            cell_x + cell_w,
            cell_y + cell_h
          );
        } else if (cg[0] === 0 && cg[1] === 1) {
          // Tails, Heads
          p55.triangle(
            cell_x,
            cell_y,
            cell_x + cell_w,
            cell_y,
            cell_x,
            cell_y + cell_h
          );
        } else if (cg[0] === 0 && cg[1] === 0) {
          // Tails, Tails
          p55.triangle(
            cell_x + cell_w,
            cell_y,
            cell_x + cell_w,
            cell_y + cell_h,
            cell_x,
            cell_y + cell_h
          );
        }
      }
    }

    if (preview_triggered === false) {
      $fx.preview();
      preview_triggered = true;
    }
  };

  let flip_val = function () {
    return Math.floor($fx.rand() * 2);
  };

  p55.keyPressed = () => {
    switch (p55.key) {
      case "s":
        export_img();
        break;
      default:
    }
  };

  const export_img = function (rating = "NA") {
    const sk_name = config.sketch_name;
    const datetime = get_datetime_str();
    const res = `${scene.min_dim}x${scene.min_dim}`;
    const grid_dims = `${cols}x${rows}`;
    const filename = `${sk_name}-${config.author}-${datetime}-${res}-${grid_dims}-${fxhash}`;
    p55.save(filename);
    console.log(`saving image to: ${filename}`);
  };
});
